import { ScaleElement } from '@scale/base-element';

class ScaleHeaderNotifications extends ScaleElement {
  #trigger;

  setup() {
    this.#trigger = this.querySelector('[aria-expanded]');

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.#close();
    }, { signal: this.signal });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#close();
    }, { signal: this.signal });
  }

  toggle() {
    const dropdown = this.ref('dropdown');
    if (!dropdown) return;

    if (dropdown.classList.contains('is-open')) {
      this.#close();
    } else {
      this.#open();
    }
  }

  #open() {
    const dropdown = this.ref('dropdown');
    if (!dropdown) return;

    dropdown.classList.add('is-open');
    dropdown.setAttribute('aria-hidden', 'false');
    this.#trigger?.setAttribute('aria-expanded', 'true');
  }

  #close() {
    const dropdown = this.ref('dropdown');
    if (!dropdown) return;

    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');
    this.#trigger?.setAttribute('aria-expanded', 'false');
  }

  onBlockSelect() { this.#open(); }
  onBlockDeselect() { this.#close(); }
}

if (!customElements.get('scale-header-notifications')) {
  customElements.define('scale-header-notifications', ScaleHeaderNotifications);
}
